import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import SuccessFullyStore from '@src/pages/successfully/store';
import Page from '../../components/page';

import Link from '@src/components/link';
const styles = require('./index.less');

const SuccessFully = ({ store }) => {
  store.use();

  return (
    <Page className={styles.root}>
      <div className={styles.kv} />
      <div className={styles.successBox}>
        <div className={styles.icon} style={{ backgroundImage: `url("${store.pageConfig.success_slogan ? store.pageConfig.success_slogan[0].url : ''}")` }} />
        <div className={styles.title}>{store.pageConfig.success_title}</div>
        {/* <div className={styles.text}>{`${store.pageConfig.success_first} [${store.title} ]\n${store.pageConfig.success_second}`} </div> */}

        <div className={styles.text}>{`${store.pageConfig.success_first} 【${store.title}】\n${store.pageConfig.success_second}`} </div>
        <div className={styles.btnBox}>
          <Link className={styles.btnJobList} onClick={() => store.goList()}>
            {store.pageConfig.go_list}
          </Link>
          <Link className={styles.btnGoRecord} onClick={() => store.clickJobRecord()}>
            {store.pageConfig.go_record}
          </Link>
        </div>
      </div>
    </Page>
  );
};

export default wrapStore(SuccessFully, SuccessFullyStore);
